<template>
	<form @submit.prevent="createSight()">
		<div class="row">
			<div class="col-sm-8">
				<div class="row">
					<div class="form-group col-sm-4 mb-5">
						<BaseMultiSelect
							@update:value="setCountry"
							:options="geo.countriesSelect"
							rules="required"
							name="Country"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-4 mb-5">
						<BaseMultiSelect
							@change:value="getCities"
							@update:value="setCity"
							:options="geo.citiesSelect"
							rules="required"
							name="City"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-4 mb-4">
						<BaseInput
							name="activity"
							label="Activity"
							type="text"
							class="form-control form-control-lg dashInput"
							v-model="data.activity"
							rules="required|min:3"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-12 mb-5">
						<label for="description" class="form-label small custom-dark-text"
							>Description</label
						>
						<textarea
							v-model="data.description"
							class="form-control form-control-lg"
							id="description"
						></textarea>
					</div>
					<div class="form-group col-sm-12 mb-5">
						<BaseEditor @updateData="setInclusion" name="Inclusion" />
					</div>
					<div class="form-group col-sm-12 mb-5">
						<BaseEditor @updateData="setExclusion" name="Exclusion" />
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="duration"
							label="Duration"
							type="text"
							v-model="data.duration"
							class="form-control form-control-lg dashInput"
							rules="required|min:1|max:50"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="closeDay"
							label="Close Day"
							type="text"
							v-model="data.closeDay"
							class="form-control form-control-lg dashInput"
							rules="required|min:1|max:50"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="openCloseTime"
							label="Open Close Time"
							type="text"
							v-model="data.openCloseTime"
							class="form-control form-control-lg dashInput"
							rules="required|min:1|max:20"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>

					<div class="form-group col-sm-3 mb-5">
						<BaseMultiSelect
							@update:value="setTransport"
							:options="transports.selectOptions"
							rules="required"
							name="Transports"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>

					<div class="form-group col-sm-3 mb-4">
						<BaseInput
							name="startTime"
							label="Start Time"
							type="time"
							v-model="data.startTime"
							class="form-control form-control-lg dashInput"
							rules="required|min:1|max:20"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-4 mb-5">
						<label for="remark" class="form-label small text-dark"
							>Remark</label
						>
						<textarea
							v-model="data.remark"
							class="form-control form-control-lg"
							id="remark"
						></textarea>
					</div>
					<div class="form-group col-sm-4 mb-5">
						<label for="remarkOne" class="form-label small text-dark"
							>Remark One</label
						>
						<textarea
							v-model="data.remarkOne"
							class="form-control form-control-lg"
							id="remarkOne"
						></textarea>
					</div>
					<div class="form-group col-sm-4 mb-5">
						<label for="remarkTwo" class="form-label small text-dark"
							>Remark Two</label
						>
						<textarea
							v-model="data.remarkTwo"
							class="form-control form-control-lg"
							id="remarkTwo"
						></textarea>
					</div>
					<div class="col-sm-12">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="image.enabled"
								type="checkbox"
								id="imageCheck"
							/>
							<label class="form-check-label text-dark" for="imageCheck"
								>Upload sight image</label
							>
						</div>
					</div>

					<div v-if="image.enabled" class="col-sm-12">
						<BaseImageUpload urlParam="sights" @images-data="setImage" />
					</div>
					<div class="form-group col-sm-6 mt-2">
						<BaseButton
							class="btn btn-primary form-control form-control-lg"
							type="submit"
							label="Save"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<div class="col-sm-4 px-4">
				<h4 class="text-dark">Global Trip Holidays</h4>
				<p class="text-dark">
					Contacts are your customers you interact with in pursuit of a business
					opportunity.
				</p>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, watch } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";
	import formCheck from "@/helpers/formCheckHelper";
	import BaseInput from "./BaseInput.vue";
	import BaseFileInput from "./BaseFileInput.vue";
	import BaseButton from "./BaseButton.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseEditor from "./BaseEditor.vue";
	import BaseImageUpload from "./BaseImageUpload.vue";

	export default {
		name: "SightCreate",
		components: {
			BaseInput,
			BaseFileInput,
			BaseButton,
			BaseMultiSelect,
			BaseEditor,
			BaseImageUpload,
		},
		setup: () => {
			const data = reactive({
				country: null,
				city: null,
				activity: null,
				description: null,
				inclusion: null,
				exclusion: null,
				duration: null,
				closeDay: null,
				openCloseTime: null,
				transport: null,
				startTime: null,
				remark: null,
				remarkOne: null,
				remarkTwo: null,
				images: [],
			});

			const geo = reactive({
				countries: {},
				countriesSelect: {},
				selectedCountry: {
					id: null,
					name: null,
				},
				cities: {},
				citiesSelect: {},
				states: {},
			});

			const transports = reactive({
				selectOptions: Helper.transports,
			});

			const formState = reactive({
				isLoading: false,
				disable: false,
			});

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: [
					"description",
					"inclusion",
					"exclusion",
					"duration",
					"closeDay",
					"openCloseTime",
					"transport",
					"startTime",
					"remark",
					"remarkOne",
					"remarkTwo",
					"images",
				],
			});

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);
			const removeState = () => {
				let keys = Object.keys(data);

				keys.map((key) => {
					if (data[key] instanceof Array) {
						data[key] = [];
					} else if (
						!data[key] instanceof Array &&
						data[key] instanceof Object
					) {
						data[key] = {};
					} else data[key] = null;
				});
			};

			const createSight = async () => {
				changeFormLoadingState();
				formState.disable = true;

				if (validation.invalid.length) {
					toast.error("Incomplete form", true);
					changeFormLoadingState();
					return;
				}

				try {
					await API.privateRequest.post("sights", data);
					toast.success(
						{ message: "Sight created!", position: "topRight" },
						true,
					);
					removeState();
					changeFormLoadingState();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
					changeFormLoadingState();
				}
			};

			const uploadImage = async (e) => {
				try {
					changeFormLoadingState();
					// let setByThis = false;
					// if (!formState.disable) {
					// 	formState.disable = true;
					// 	setByThis = true;
					// }
					const formData = new FormData();
					formData.append("attachment", e[0], e[0].name);
					const response = await API.privateRequest.post("files?sights=1", formData, {
						headers: { "Content-Type": "multipart/form-data" },
					});
					data.images.push(response.data.data[0].url);
					changeFormLoadingState();
					// if (setByThis && formState.disable) formState.disable = false;
				} catch (err) {
					changeFormLoadingState();
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			//? adding and removing form fields from valid and invalid state
			const setFormVal = (data) => {
				if (validation.invalid.length) {
					const newInvalid = validation.invalid.filter(
						(error) => error.field !== data.field,
					);
					validation.invalid = newInvalid;
				}
				if (validation.valid.length) {
					const newValid = validation.valid.filter(
						(item) => item.field !== data.field,
					);
					validation.valid = newValid;
				}
				return;
			};

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					geo.countries = countries;
					geo.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (id) => {
				if (!id) {
					data.country = { id: 0, name: null };
					return;
				}
				const country = geo.countries.filter((country) => country.id === id);
				data.country = { id: country[0].id, name: country[0].name };
			};

			// ! City Functions

			const getCities = async (name, type = false) => {
				if (!name) return;
				let data = {};
				if (type && type === "country") data = { countryName: name };
				else if (name.length < 3) return;
				else data.name = name.name;
				try {
					const cities = await Helper.getCities(data);
					geo.cities = cities;
					geo.citiesSelect = cities.map((city) => ({
						label: `${city.name} ( ${city.state_name} )`,
						value: city.id,
					}));
				} catch (error) {
					console.log(error);
				}
			};

			watch(
				() => data.country,
				(newCountry, prevCountry) => {
					if (!newCountry) return;
					getCities(newCountry.name, "country");
				},
			);
			const setCity = (id) => {
				if (!id) {
					data.city = { id: 0, name: null, state_name: null };
					return;
				}
				const city = geo.cities.filter((city) => city.id === id);
				data.city = {
					id: city[0].id,
					name: city[0].name,
					state_name: city[0].state_name,
				};
			};

			const setTransport = async (transportType) => {
				data.transport = transportType;
			};

			const setExclusion = (payload) => {
				data.exclusion = payload;
			};
			const setInclusion = (payload) => {
				data.inclusion = payload;
			};

			const image = reactive({
				enabled: false,
			});

			const setImage = (images) => {
				if (!images.length) return;
				data.images = [...data.images, ...images];
				formState.disable = false;
			};

			// event handler for valError event
			const valError = (input) => {
				// setFormVal(input);
				// validation.invalid = [...validation.invalid, input];
				// let check = formCheck(validation, data);
				// if (check) formState.disable = false;
				// else formState.disable = true;
			};

			const valSuccess = (input) => {
				// setFormVal(input);
				// validation.valid = [...validation.valid, input];
				// let check = formCheck(validation, data);
				// if (check) formState.disable = false;
				// else formState.disable = true;
			};

			return {
				geo,
				setCountry,
				getCities,
				setCity,
				transports,
				data,
				image,
				validation,
				formState,
				createSight,
				valError,
				valSuccess,
				uploadImage,
				setTransport,
				setExclusion,
				setInclusion,
				setImage,
			};
		},
	};
</script>
